import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { dayjsSetup } from './utility/dayjs.helper'
import { Main } from './pages/main';
import { NewChart } from './pages/new-chart/new-chart';
import { Login } from './pages/login';
import { Navbar } from './components/navbar';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Transit } from './pages/transit';
import { Privacy } from './pages/privacy';
import { Eula } from './pages/euala';



function App() {
  const queryClient = new QueryClient();
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <Router>
          <Navbar />
          <Routes>
            <Route path="" element={<Transit />}/>
            <Route path="/login" element={<Login />}/>
            <Route path="new-chart/new-chart" element={<NewChart />}/>
            <Route path="transit" element={<Transit/>}/>
            <Route path="privacy" element={<Privacy/>}/>
            <Route path="/eula" element={<Eula />} />
          </Routes>
        </Router>
      </QueryClientProvider>
    </div>
  );
}
dayjsSetup()
export default App;
